import { render, staticRenderFns } from "./industrial-track-proposal.vue?vue&type=template&id=ec3cfe2a&scoped=true&"
import script from "./industrial-track-proposal.vue?vue&type=script&lang=js&"
export * from "./industrial-track-proposal.vue?vue&type=script&lang=js&"
import style0 from "./industrial-track-proposal.vue?vue&type=style&index=0&id=ec3cfe2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3cfe2a",
  null
  
)

export default component.exports